<template>
  <div class="faq-category" data-test="faq-category">
    <h2 :key="faq.categoryName">
      {{ faq.categoryName }}
    </h2>
    <ui-collapse
      v-for="question of faq.questions"
      :key="question.slug"
      :collapse-id="`collapse-faq-${question.slug}`"
    >
      <template #ui-collapse-title>
        <div class="expand-title">
          {{ question.name }}
        </div>
      </template>
      <template #ui-collapse-body>
        <div v-thtml="question.answer" />
      </template>
    </ui-collapse>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Faq } from '../schemas'

@Component
class FaqCategory extends Vue {
  @Prop()
  faq: Faq
}

export default toNative(FaqCategory)
</script>
<style scoped>
.faq-category .ui-collapse:last-of-type {
  border-bottom: 1px solid #ddd;
}
.faq-category > h2 {
  margin-top: 1.5em;
  line-height: 1.1;
  font-weight: 500;
}

.faq-category :deep(.ui-collapse-content p) {
  line-height: 1.4;
}

.faq-category :deep(.ui-collapse-content p) {
  line-height: 1.4;
}

.faq-category :deep(.ui-collapse-content ul) {
  margin-bottom: 1em;
}

.faq-category :deep(.ui-collapse-content li) {
  display: list-item;
  list-style: disc inside;
}
</style>
